'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _httpConstants = require('../../../utils/http/httpConstants');

var _timeUtil = require('../../../utils/timeUtil');

// Constants
exports.default = function (mediaHttp) {
    return {
        fetchLink: function fetchLink(_ref) {
            var id = _ref.id,
                url = _ref.url;

            var requestConfig = {
                url: 'link',
                method: _httpConstants.METHODS.POST,
                timeout: _timeUtil.TIMES.MINUTE,
                data: {
                    url: url,
                    elementId: id
                }
            };

            return mediaHttp(requestConfig);
        },
        fetchLinkAttachment: function fetchLinkAttachment(_ref2) {
            var id = _ref2.id,
                url = _ref2.url;

            var requestConfig = {
                url: 'link/attachments',
                method: _httpConstants.METHODS.POST,
                timeout: _timeUtil.TIMES.MINUTE,
                data: {
                    url: url,
                    elementId: id
                }
            };

            return mediaHttp(requestConfig);
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/media/mediaService/api/createLinkApi.js
// module id = 2282
// module chunks = 0